
      import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';
      createChat({
        webhookUrl: 'https://primary-production-b0ec2.up.railway.app/webhook/b7209cc7-560c-4128-8954-dfbbbf14b599/chat',
        mode: 'window',
        showWelcomeScreen: false,
        initialMessages: [
          'Hey 👋',
          'This is Luna, Spilios AI Assistant. How can I help?'
        ],
      });
    